import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Trophy, Star } from 'lucide-react';
import { Section } from './Shared';
type PlanId = 'maestria' | 'base';
const plans: {
  id: PlanId;
  emoji: string;
  name: string;
  desc: string;
  ideal: string;
  oldPrice: string;
  price: string;
  href: string;
  recommended: boolean;
}[] = [{
  id: 'maestria',
  emoji: '🌟',
  name: 'MEGA KIT DEL INTERVENTOR AKÁSHICO™',
  desc: 'Kit Profesional + Kit El Altar del Terapeuta Akáshico™',
  ideal: 'Ideal para: dominar las sesiones Y construir una práctica profesional que atraiga consultantes.',
  oldPrice: '$129.000',
  price: '$29.990 ARS',
  href: 'https://www.lumenakasha.com/cart/46955075698877:1',
  recommended: true
}, {
  id: 'base',
  emoji: '📘',
  name: 'KIT PROFESIONAL DEL INTERVENTOR AKÁSHICO™',
  desc: 'Tratado del Interventor Akáshico™ + 3 Bonus',
  ideal: 'Ideal para: interpretar mejor y llevar sesiones más profundas.',
  oldPrice: '$89.000',
  price: '$19.990 ARS',
  href: 'https://www.lumenakasha.com/cart/46954885316797:1',
  recommended: false
}];
export const Pricing = () => {
  const [selected, setSelected] = useState<PlanId>('maestria');
  const selectedPlan = plans.find(p => p.id === selected)!;
  return <Section id="pricing" className="bg-brand-surfaceLight/60 rounded-3xl my-12 border border-brand-purple/20" data-id="element-356">
      <div className="text-center mb-10" data-id="element-357">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-purpleDark" data-id="element-358">
          ELEGÍ TU <span className="purple-gradient-text" data-id="element-359">KIT</span>
        </h2>
        <p className="text-brand-text/70 mt-3 text-sm md:text-base" data-id="element-360">
          ⏰ El precio de lanzamiento cierra pronto. Después aumenta y no
          vuelve.
        </p>
      </div>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-361">
        {plans.map(plan => {
        const isSelected = selected === plan.id;
        return <motion.button key={plan.id} type="button" onClick={() => setSelected(plan.id)} whileTap={{
          scale: 0.99
        }} aria-pressed={isSelected} className={`w-full text-left rounded-2xl md:rounded-3xl p-4 md:p-6 border-2 transition-all duration-300 ${isSelected ? 'border-brand-purple bg-white shadow-[0_0_24px_rgba(124,58,237,0.2)]' : 'border-brand-purple/20 bg-white/70 hover:border-brand-purple/50'}`} data-id="element-362">
              <div className="flex items-start gap-3 md:gap-4" data-id="element-363">
                <div className="shrink-0 mt-1" data-id="element-364">
                  <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-brand-purple' : 'border-brand-purple/40'}`} data-id="element-365">
                    {isSelected && <motion.div initial={{
                  scale: 0
                }} animate={{
                  scale: 1
                }} className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-brand-purple" data-id="element-366" />}
                  </div>
                </div>

                <div className="flex-1 min-w-0" data-id="element-367">
                  {plan.recommended && <div className="flex items-center gap-1.5 mb-1.5 text-brand-purple" data-id="element-368">
                      <Trophy className="w-4 h-4 fill-brand-purple" data-id="element-369" />
                      <Star className="w-3.5 h-3.5 fill-brand-purple" data-id="element-370" />
                      <span className="text-[10px] md:text-sm font-bold tracking-wider uppercase" data-id="element-371">
                        Más elegido
                      </span>
                    </div>}

                  <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1" data-id="element-372">
                    <div className="min-w-0" data-id="element-373">
                      <h3 className="font-serif font-bold text-sm md:text-lg text-brand-purpleDark leading-tight" data-id="element-374">
                        <span className="mr-1.5" data-id="element-375">{plan.emoji}</span>
                        {plan.name}
                      </h3>
                      <p className="text-xs md:text-sm text-brand-text/70 mt-1" data-id="element-376">
                        {plan.desc}
                      </p>
                      <p className="text-[11px] md:text-sm text-brand-purple font-medium mt-1.5" data-id="element-377">
                        {plan.ideal}
                      </p>
                    </div>

                    <div className="text-right shrink-0" data-id="element-378">
                      <p className="text-xs md:text-sm text-brand-text/40 line-through leading-none" data-id="element-379">
                        {plan.oldPrice}
                      </p>
                      <p className={`font-serif font-bold text-lg md:text-2xl leading-tight mt-1 ${isSelected ? 'text-brand-purple' : 'text-brand-text'}`} data-id="element-380">
                        {plan.price}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.button>;
      })}

        <motion.a href={selectedPlan.href} animate={{
        scale: [1, 1.025, 1],
        y: [0, -2, 0]
      }} transition={{
        duration: 2.4,
        ease: 'easeInOut',
        repeat: Infinity
      }} whileHover={{
        scale: 1.04,
        y: -3,
        transition: {
          duration: 0.25
        }
      }} whileTap={{
        scale: 0.98
      }} className="mt-6 w-full inline-flex items-center justify-center px-6 py-4 md:py-5 text-sm md:text-lg font-bold text-white purple-gradient-bg rounded-full animate-glow-pulse relative overflow-hidden cta-shimmer shadow-[0_0_20px_rgba(124,58,237,0.4)]" data-id="element-381">
          <span className="relative z-10" data-id="element-382">
            → QUIERO EL{' '}
            {selectedPlan.id === 'maestria' ? 'MEGA KIT' : 'KIT PROFESIONAL'}{' '}
            {selectedPlan.price.split(' ')[0]}
          </span>
        </motion.a>

        <p className="text-center text-xs md:text-sm text-brand-text/60 pt-2" data-id="element-383">
          🛡️ Garantía 7 días · 📥 Descarga inmediata · 🔒 Pago seguro · 💳
          Mercado Pago
        </p>
      </div>
    </Section>;
};